import { render, staticRenderFns } from "./OcultarButacas.vue?vue&type=template&id=ec71ebea&scoped=true"
import script from "./OcultarButacas.vue?vue&type=script&lang=js"
export * from "./OcultarButacas.vue?vue&type=script&lang=js"
import style0 from "./OcultarButacas.vue?vue&type=style&index=0&id=ec71ebea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec71ebea",
  null
  
)

export default component.exports